// eslint-disable-next-line import/order -- FIXME
import classNames from 'classnames';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';

const style = {
  grid: {
    padding: '0 15px !important',
    margin: '5px 0',
  },
};

// eslint-disable-next-line func-style -- FIXME
function GridItem({ ...props }) {
  const { classes, children, className, ...rest } = props;
  return (
    <Grid item={true} {...rest} className={classNames(classes.grid, className)}>
      {children}
    </Grid>
  );
}

export default withStyles(style)(GridItem);
